<div class="chat-container" [class.reading]="showChatPopup">
  <div class="chat-popup" [class.hide]="!showChatPopup">
    <app-chat-box [messages]="messages" (sendMessage)="onSendMessage($event)"></app-chat-box>
  </div>

  <div class="chat-button-wrapper">
    <div class="chat-button" (click)="onClickChatButton()" [class.close]="showChatPopup"
      [class.has-new-message]="!showChatPopup && hasNewMessage">
      <img [src]="!showChatPopup ? 'assets/icons/icon-message.svg' : 'assets/icons/icon-x.svg'" alt="chat button">
    </div>
  </div>
</div>